import { Link } from "react-router-dom";

export default function RCArticleBottomCTA() {
  return (
    <section className="relative py-28 overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/b5323aaf75ddf9e0d5e5a2f204ac4512.jpg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-[#FAF7F0]/85" />

      <div className="relative z-10 max-w-screen-xl mx-auto px-8 md:px-16 text-center">
        <p
          className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-5"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Keep Exploring
        </p>
        <h2
          className="text-[#2C2825] text-3xl md:text-5xl leading-snug max-w-2xl mx-auto mb-5"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
        >
          Looking for more peaceful interiors?
        </h2>
        <p
          className="text-[#8B8378] text-sm leading-relaxed max-w-lg mx-auto mb-10"
          style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
        >
          Explore more living rooms, cozy corners, and warm neutral spaces designed for slower, softer living.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/living-room"
            className="inline-flex items-center gap-2.5 bg-[#2C2825] text-white px-10 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#4A3F38] transition-all duration-300 cursor-pointer whitespace-nowrap uppercase"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            View Living Rooms
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs" />
            </span>
          </Link>
          <Link
            to="/cozy-corners"
            className="inline-flex items-center gap-2.5 border border-[#C8BAA8] text-[#6B5E53] px-10 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap uppercase"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Explore Cozy Corners
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
